import { useDispatch } from 'react-redux';
import { openChat } from '~/src/store/actions/chat';
import { Link } from './styled';

interface IProps {
    children?: JSX.Element | JSX.Element[],
}

const OpenChat = ({ children }: IProps): JSX.Element => {
    const dispatch = useDispatch();
    return <Link onClick={() => dispatch(openChat())}>
        {
            children == null
                ? 'чат'
                : children
        }
    </Link>;
};

export default OpenChat;
